import Link from 'next/link';
import { DIRECTORY_CITIES } from '@/constants/directoryCities';
import './discovery-links.css';

// Both presentations use the same destinations and render on the server.
const groups = [
  { title: 'Espacios musicales por ciudad', links: DIRECTORY_CITIES.map(city => ({ href: `/directorio/${city.slug}`, label: `Música en ${city.display}` })) },
  { title: 'Da tu próximo paso', links: [
    { href: '/directorio', label: 'Explora el directorio de música' },
    { href: '/beta', label: 'Apúntate a la beta para músicos' },
    { href: '/blog', label: 'Blog y recursos' },
  ] },
  { title: 'Gestiona tu espacio', links: [
    { href: '/escuelas', label: 'Gestión de escuelas de música' },
    { href: '/salas', label: 'Gestión de locales de ensayo' },
    { href: '/reclama-tu-ficha', label: 'Reclama la ficha de tu negocio' },
  ] },
];
function Links({ links }: { links: typeof groups[number]['links'] }) {
  return <ul>{links.map(link => <li key={link.href}><Link href={link.href}>{link.label}</Link></li>)}</ul>;
}
export default function DiscoveryLinks({ className = '' }: { className?: string }) {
  return <section id="recursos" className={`discovery-links ${className}`} aria-labelledby="discovery-title">
    <div className="discovery-inner">
      <h2 id="discovery-title">Encuentra tu lugar para hacer música</h2>
      <p>Consulta el directorio para conocer escuelas, locales de ensayo y otros espacios musicales. Revisa en cada ficha sus servicios y datos de contacto antes de elegir.</p>
      <div className="discovery-columns">{groups.map(group => <nav key={group.title} aria-label={group.title}><h3>{group.title}</h3><Links links={group.links} /></nav>)}</div>
      <div className="discovery-mobile-groups">{groups.map(group => <details key={group.title}><summary>{group.title}</summary><nav aria-label={group.title}><Links links={group.links} /></nav></details>)}</div>
    </div>
  </section>;
}
